import styled from 'styled-components';

const FooterHolder = styled.div`
   background-color: white;
   border-top: 2px solid rgba(25,25,25,.2);
   grid-area: footer;   
   .footer {
		display: flex;
		flex-flow: wrap row;
		color: #7a7652;
		padding: 0 25px 0 25px;
		background: white url(/static-assets/theme/svg/bottom-decoration.svg) right 6px bottom 6px no-repeat;
		background-size: 25vw;
		a {
			font-family: "Open Sans", sans-serif;
			color: #7a7652;
			text-decoration: none;
			font-weight: 600;
			font-size: 16px;

			:hover {
				color: #5f7586;
			}
		}

		&__links{
			width: 50%;
			&__container{
				width: 100%;
				margin-top: 18px;
				display: grid;
				grid-template-columns: 1fr 1fr;
				grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
				gap: 1px 18px;
				@media only screen and (max-width: 920px) {
					grid-template-columns: 1fr;
				}
			}
			&__copyright {
				width: 100%;
				text-align: left;
				color: #383838;
				line-height: 1.5em;
				margin-bottom: 40px;
				margin-top: 45px;
				font-size: 12px;
				font-weight: 500;
				font-family: "Open Sans", sans-serif;

				&.is-mobile {
					display: none;
				}

				@media only screen and (max-width: 920px) {
					display: none;
					&.is-mobile {
						display: block;
					}
				}
			}
		}

		&__sponsors {
			width: 50%;
			&__title {
				color: #1b1b1b;
				font-weight: 500;
				font-size: 18px;
			}
			&__images-cont{
				width: 45%;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				grid-template-rows: 1fr 1fr;
				gap: 10px 0;
				@media only screen and (max-width: 920px) {
					grid-template-columns: 0fr 1fr;
				}
				@media only screen and (max-width: 548px) {
					grid-template-columns: 1fr;
					gap: 0px;
				}
			}
			a {
				min-width: 100px;
				max-width: 100px;
				max-height: 32px;
				margin: 10px 20px 10px 0;
			}
			img {
				width: 100%;
    			height: auto;
			}
		}
   }
`;

export default FooterHolder;